const findDefaultAddress = (addresses, type) => {
  const typeKey = `is${type}`;

  return (
    addresses.find((address) => address.isDefault && address[typeKey]) ||
    addresses.find((address) => address[typeKey]) ||
    addresses.find((address) => address.isDefault) ||
    {}
  );
};

const createAddressObject = (defaultAddress) => ({
  id: defaultAddress.id || null,
  address: defaultAddress.address || '',
  address2: defaultAddress.address2 || '',
  city: defaultAddress.city || '',
  country: defaultAddress.country || 'US',
  region: defaultAddress.region || '',
  postalCode: defaultAddress.postalCode || '',
  isDefault: false,
});

function initialValues({ account = {}, user = {}, cartId }) {
  const { accountAddresses = [] } = account || {};

  const defaultShipping = findDefaultAddress(accountAddresses, 'Shipping');
  const defaultBilling = findDefaultAddress(accountAddresses, 'Billing');

  return {
    cartId,
    deliveryMethod: 'standard',
    acceptedTerms: false,
    creditCard: {
      id: null,
      nameOnCard: `${user?.firstName || ''} ${user?.lastName || ''}`.trim(),
      cardNumber: '',
      expirationDate: '',
      cvv: '',
    },
    billingAddress: createAddressObject(defaultBilling),
    shippingAddress: createAddressObject(defaultShipping),
  };
}

export default initialValues;
